import React from 'react';
export function About() {
  return <section aria-labelledby="about-title" className="bg-cream py-16 md:py-24" data-id="element-1" data-mp="2ws8ys9ft1ydu">
      <div className="mx-auto max-w-2xl px-5 text-center" data-id="element-2" data-mp="38zdpkte0no82">
        <h2 id="about-title" className="font-serif text-[2.1rem] leading-[1.08] text-ink md:text-5xl" data-id="element-3" data-mp="3e01e98ervsz4">
          Sobre Sesiones Listas™
        </h2>
        <p className="mt-6 text-lg leading-relaxed text-muted" data-id="element-4" data-mp="3iyco3j52i3hc">
          Sesiones Listas™ nació para ayudar a psicólogas y terapeutas infantiles a reducir el tiempo de preparación y
          llegar a cada sesión con recursos prácticos, organizados y listos para usar. Nuestro objetivo es simplificar
          tu organización profesional para que puedas dedicar más energía al acompañamiento de cada niño.
        </p>
        <p className="mx-auto mt-6 max-w-xl text-sm leading-relaxed text-muted/90" data-id="element-5" data-mp="3023dj5tdjv23">
          Los recursos son materiales de apoyo profesional y no sustituyen la evaluación, el criterio clínico ni la
          adaptación individual de cada caso.
        </p>
      </div>
    </section>;
}